/* global Sys, Core, Environment, Platform */
Sys.ns("Core.Slots");

Core.Slots.BonusProgramWidgetView = {
    PARENT_CONTAINER_ID: "viewport",
    viewElements: {},
    bonusProgramWidgetIframeId: "bonusProgramWidgetIframe",

    constructor: function() {
        Core.Slots.BonusProgramWidgetView.superclass.constructor.apply(this, arguments);
    },

    /**
     * Initialises the view.
     *
     * @protected
     * @returns {void}
     */
    initViewData: function() {
        var parent,
            mainContainer,
            overlay;

        mainContainer = document.createElement("div");
        overlay = document.createElement("div");
        mainContainer.appendChild(overlay);
        parent = document.getElementById(this.PARENT_CONTAINER_ID);

        mainContainer.setAttribute("id", "bonusProgramWidgetContainer");
        overlay.setAttribute("id", "bonusProgramWidgetOverlay");

        parent.appendChild(mainContainer);

        this.viewElements = {
            mainContainer: mainContainer,
            overlay: overlay
        };

        this.refresh();
    },

    /**
     * Handle orientation change event.
     *
     * @param {string} orientation The updated orientation.
     * @returns {void}
     */
    adaptToOrientation: function(orientation) {
        if (!this.model.readData("gameSizeChangedTriggered")) {
            this.fireEvent("view:orientationChanged", orientation);

            this.refresh();
        }
    },

    /**
     * Refreshes the view according to the game size.
     *
     * @returns {void}
     */
    refresh: function() {
        if (typeof this.viewElements.mainContainer !== "undefined" && Environment.getCurrentPlatform() === "mobile") {
            this.setIframeContainerHeight();
        }

        if (this.viewElements.iframe) {
            this.viewElements.iframe.style.width = "100%";
            this.viewElements.iframe.style.height = "100%";
        }
    },

    /**
     * Set size of iframe container height.
     *
     * @returns {void}
     */
    setIframeContainerHeight: function() {
        var height = Sys.utils.toInt(Environment.determineResolution().resolution.height + (Platform.isTabletDevice ? 0 : Environment.getSpaceBelowGame()));

        this.viewElements.mainContainer.style.height = height + "px";
    },

    /**
     * Sets the source of the iframe.
     *
     * @protected
     * @param {string} widgetPath The path to the widget that should be loaded in the iframe.
     * @returns {void}
     */
    loadIframePage: function(widgetPath) {
        this.removeIframeInstance();
        this.createIframeInstance(widgetPath);
    },

    /**
     * Create a new bonus widget iframe.
     *
     * @protected
     * @param {string} src The iframe soruce to load.
     * @returns {void}
     */
    createIframeInstance: function(src) {
        var iframe = document.createElement("iframe");

        iframe.setAttribute("id", this.bonusProgramWidgetIframeId);
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("allowtransparency", "true");
        iframe.setAttribute("src", src);
        iframe.setAttribute("style", "width: 100%; height: 100%");
        iframe.onload = this.refresh.bind(this);

        this.viewElements.mainContainer.appendChild(iframe);
        this.viewElements.iframe = iframe;
    },

    /**
     * Removes old iframe to fix a history state bug in firefox.
     *
     * @protected
     * @returns {void}
     */
    removeIframeInstance: function() {
        var element = document.getElementById(this.bonusProgramWidgetIframeId);

        if (element) {
            element.parentNode.removeChild(element);
            this.viewElements.iframe = null;
        }
    },

    /**
     * Closes and removes the iframe.
     *
     * @protected
     * @returns {void}
     */
    closeIframePage: function() {
        var bonusProgramWidgetContainer = this.viewElements.mainContainer;

        bonusProgramWidgetContainer.parentNode.removeChild(bonusProgramWidgetContainer);
    }
};

Core.Slots.BonusProgramWidgetView = Sys.extend(Core.View, Core.Slots.BonusProgramWidgetView, "Core.Slots.BonusProgramWidgetView");

